import './styles/globals.css';

import React from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import posthog from 'posthog-js';
import { PostHogProvider } from '@posthog/react';
import router from './router';
import PosthogContextProvider from './context/PosthogContext';

const container = document.getElementById('root');
const root = createRoot(container!);

posthog.init('phc_4Ch9ptsYXOE0EkJnBaLttDpzt5jqgpVQ58E3MQrcYc4', {
  cookieless_mode: 'always',
  api_host: 'https://sweet-paper-85d0.joel-0b7.workers.dev/',
  defaults: '2025-05-24',
  autocapture: false,
  capture_pageview: false,
  capture_pageleave: false,
  opt_out_capturing_by_default: true,
  disable_session_recording: true,
  disable_surveys: true,
  advanced_disable_feature_flags: true,
  advanced_only_evaluate_survey_feature_flags: true,
  debug: process.env.NODE_ENV === 'development',
  request_batching: false,
});

const accountId = window?.__DH_CONFIG?.accountId || 'not-set';

posthog.register({
  bndl_account_id: accountId,
});

root.render(
  <RecoilRoot>
    <PosthogContextProvider>
      <PostHogProvider client={posthog}>
        <RouterProvider router={router} />
      </PostHogProvider>
    </PosthogContextProvider>
  </RecoilRoot>,
);
